/**
 * ZAXIA Staff Layout - TopBar Component
 * Displays hotel name, user info, and logout
 *
 * Phase P2.1-5: Staff Dashboard Shell
 * - Added hamburger menu for mobile
 */

import { useAuth } from '../hooks/useAuth';

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 bg-slate-900 border-b border-slate-700 px-4 md:px-6 flex items-center justify-between">
      {/* Left: Menu Button + Hotel Name */}
      <div className="flex items-center gap-3">
        {/* Hamburger Menu - Mobile Only */}
        <button
          type="button"
          onClick={onMenuClick}
          className="lg:hidden p-2 -ml-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Hotel Logo & Name */}
        <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
          <span className="text-white font-bold text-sm">Z</span>
        </div>
        <div className="hidden sm:block">
          <h1 className="text-white font-semibold text-lg leading-tight">
            Grand Azure Palace
          </h1>
          <p className="text-slate-400 text-xs">Operations Console</p>
        </div>
      </div>

      {/* Right: User Info & Logout */}
      <div className="flex items-center gap-2 md:gap-4">
        {user && (
          <div className="text-right hidden sm:block">
            <p className="text-white text-sm font-medium">{user.name}</p>
            <p className="text-slate-400 text-xs">{user.email}</p>
          </div>
        )}
        <button
          type="button"
          onClick={logout}
          className="px-3 md:px-4 py-2 text-sm text-slate-300 hover:text-white
                     bg-slate-800 hover:bg-slate-700 border border-slate-600
                     rounded-lg transition-colors"
        >
          <span className="hidden sm:inline">Logout</span>
          <svg className="w-5 h-5 sm:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </button>
      </div>
    </header>
  );
}
